import Configuration from 'scripts/constants/Configuration';
import Meta from 'src/components/meta/Meta';

const DefaultMeta = () => <Meta
  image="https://assets.brickx.com/images/facebook-share-image.png"
  otherTags={[
    <meta key="og:type" property="og:type" content="website"/>,
    <meta key="article:author" property="article:author" content="BrickX"/>,
    <meta key="article:publisher" property="article:publisher" content="BrickX"/>,
    <meta key="fb:app_id" property="fb:app_id" content={Configuration.FACEBOOK_APP_ID}/>,
    <meta key="twitter:site" name="twitter:site" content="@brickx"/>,
    <meta key="twitter:creator" name="twitter:creator" content="@brickx"/>,
    <meta key="twitter:card" name="twitter:card" content="summary"/>,
  ]}
/>;

export default DefaultMeta;
